import { render, staticRenderFns } from "./CheckListIndicatorSetup.vue?vue&type=template&id=141245f1&"
import script from "./CheckListIndicatorSetup.vue?vue&type=script&lang=js&"
export * from "./CheckListIndicatorSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_babel-core@6.26.3_css-loader@6.7.3_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.81.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports